<template>
    <v-footer dark padless class="c-footer">
        <v-card flat tile class="verdebgmono white--text text-center">
            <v-card-text>
                <v-btn icon large href="https://www.facebook.com/larahcabelos" target="_blank" class="mx-4">
                    <v-icon color="gold" large>
                        mdi-facebook
                    </v-icon>
                </v-btn>
                <v-btn icon large href="https://www.instagram.com/larahbrazil/" target="_blank" class="mx-4">
                    <v-icon color="gold" large>
                        mdi-instagram
                    </v-icon>
                </v-btn>
                <v-btn icon large href="https://www.larahcabelos.com.br/" target="_blank" class="mx-4">
                    <v-icon color="gold" large>
                        mdi-web-box
                    </v-icon>
                </v-btn>

            </v-card-text>
            <v-card-text class="white--text pt-0 px-md-16 c-footer-text">
                <p class="px-md-16">Esperamos que você encontre o cabelo ou toplaces perfeita em nosso catálogo. Se tiver alguma dúvida ou
                    precisar de assistência, não hesite em nos contatar.</p>
                <p class="px-md-16">As imagens são ilustrativas e têm o objetivo de exemplificar o produto que está sendo adquirido. Por
                    favor, leve em consideração que a iluminação e o preparo do penteado foram realizados por um
                    profissional experiente para apresentar o produto da melhor forma possível.</p>
            </v-card-text>
            <v-divider></v-divider>

            <v-card-text class="gold--text">
                {{ new Date().getFullYear() }} | © <strong>Larah Hair</strong> | Todos os direitos reservados
            </v-card-text>
        </v-card>
    </v-footer>
</template>
  
<script>
export default {
    name: "Footer-screen",
    props: {},
    components: {},
    data: () => ({
        icons: [
            'mdi-facebook',
            'mdi-twitter',
            'mdi-linkedin',
            'mdi-instagram',
        ],
    }),
};
</script>
  
<style>
.c-footer .v-card {
    width: 100%;
}
</style>